import { persistentAtom } from './persistence';
import type { Reminder } from '@/data/reminders';

export const $reminders = persistentAtom<Reminder[]>('reminders', []);

export function removeReminder(id: string) {
  $reminders.set($reminders.get().filter(reminder => reminder.id !== id));
}

export function addReminder(reminder: Reminder) {
  $reminders.set([...$reminders.get(), reminder]);
}
